import api from './auth'

// 获取用户列表
export const getUsers = (params) => {
  return api.get('/work/users/', { params })
}

// 获取用户详情
export const getUser = (id) => {
  return api.get(`/work/users/${id}`)
}

// 创建用户
export const createUser = (data) => {
  return api.post('/work/users/', data)
}

// 更新用户
export const updateUser = (id, data) => {
  return api.put(`/work/users/${id}`, data)
}

// 删除用户
export const deleteUser = (id) => {
  return api.delete(`/work/users/${id}`)
}

// // 获取数据范围选项
// export const getDataScopeOptions = () => {
//   return api.get('/work/users/data-scopes/options')
// }

// 新增：重置密码
export const resetPassword = (userId, data) => {
  return api.post(`/work/users/${userId}/reset-password`, data)
}

// 修改用户密码（兼容旧版 store 调用，实际为管理员重置用户密码；新代码请使用 resetPassword）
export const changePassword = (userId, data) => {
  const payload = {
    password: data?.new_password || data?.password || '',
    confirm_password: data?.confirm_password
  }
  return api.post(`/work/users/${userId}/reset-password`, payload)
}

// 新增：管理员重置两步验证（兜底恢复，强制关闭并解绑验证器）
export const resetUserTwoFactor = (userId) => {
  return api.post(`/work/users/${userId}/reset-two-factor`)
}

// 新增：批量导入用户
export const batchImportUsersExcel = (file) => {
  const formData = new FormData()
  formData.append('file', file)

  return api.post('/work/users/batch-import/excel', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 新增：下载导入模板
export const getBatchImportTemplate = () => {
  return api.get('/work/users/batch-import/template', {
    responseType: 'blob' // 重要：指定响应类型为 blob
  })
}

// 上传头像
export const updateAvatar = (formData) => {
  return api.put('/work/users/avatar', formData, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


// 移除头像
export const removeAvatar = () => {
  return api.delete('/work/users/avatar')
}

// 获取个人工单统计
export const getUserPersonalStats = (params) => {
  return api.get('/work/workorders/personal-stats', { params })
}

export const getCosTokenForAvatar = () => {
  return api.get('/work/users/avatar/cos-token')
}